import React, { ReactNode } from 'react';
import { KibIngressCard } from '@chewy/kib-cards-react';
import { KibSpinningLoader } from '@chewy/kib-overlays-react';
import './manage-pet-card.scss';

export type ManagePetCardProps = {
  className: string;
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  onClick: () => void;
  loading: boolean;
  disabled: boolean;
};

export const ManagePetCard = ({
  className,
  title,
  subtitle,
  icon,
  onClick,
  loading,
  disabled,
}: ManagePetCardProps) => (
  <div className={`manage-pet-card ${className}`}>
    <div className="manage-pet-card__wrapper" data-testid="manage-pet-card__wrapper">
      {loading ? <KibSpinningLoader embedded /> : null}
      <KibIngressCard
        className="manage-pet-card__ingress-card"
        data-testid="manage-pet-card__ingress-card"
        title={title}
        subtitle={subtitle}
        icon={icon}
        onClick={() => onClick()}
        disabled={loading || disabled}
      />
    </div>
  </div>
);
